import { CodeSnippetContainer } from '../CodeSnippet';
import { HomeCard } from '../components/HomeCard';
import { HomeCardId, mapIdToTitle } from '../constants';

export function Quickstart() {
  return (
    <HomeCard title={mapIdToTitle[HomeCardId.Quickstart]} description="Install the SDK, authenticate, and run your first model in minutes.">
      <CodeSnippetContainer />
    </HomeCard>
  );
}
